<template>
    <div>
        <template>
            <h4 class="not-margin"
                :style="{ fontWeight: 'bold', color: '#195BFF', fontSize: '18px', textAlign: 'left' }">
                <i class="fad fa-pencil-alt" :style="{ width: '25px', fontSize: '18px' }"></i>
                ເເກ້ໄຂ ທີ່ຢູ່ຂົນສົ່ງ ( Shipping Address )
            </h4>
        </template>

        <div class="columns is-multiline" :style="{ marginTop: '20px' }">
            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ຫົວຂໍ້ ( Title ) <span style="color: #888">- ບໍ່ບັງຄັບ</span>
                        <span class="text-danger">{{ server_errors.title }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="title"
                        placeholder="..."
                        v-model="shippingAddress.title"
                        maxlength="255"
                    >
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ຊື່ຜູ້ຮັບ
                        <span class="text-danger">* {{ errors.first('receiver_name') }}</span>
                        <span class="text-danger">{{ server_errors.receiver_name }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="receiver_name"
                        v-model="shippingAddress.receiver_name"
                        v-validate="'required|max:255'"
                        maxlength="255"
                    >
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ເບີໂທ
                        <span class="text-danger">* {{ errors.first('phone') }}</span>
                        <span class="text-danger">{{ server_errors.phone }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="phone"
                        v-model="shippingAddress.phone"
                        v-validate="'required|max:32'"
                        maxlength="32"
                    >
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ລະຫັດໄປສະນີ <span style="color: #888">- ບໍ່ບັງຄັບ</span>
                        <span class="text-danger">{{ server_errors.postal_code }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="postal_code"
                        v-model="shippingAddress.postal_code"
                        maxlength="16"
                    >
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ປະເພດການຂົນສົ່ງ
                        <span class="text-danger">* {{ errors.first('transport_type') }}</span>
                        <span class="text-danger">{{ server_errors.transport_type }}</span>
                    </label>
                    <div class="select">
                        <select
                            class="input"
                            name="transport_type"
                            v-model="shippingAddress.transport_type"
                            v-validate="'required'"
                        >
                            <option v-for="(t, i) in transportTypes" :key="i" :value="t.id">{{ t.name }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ປະເທດປາຍທາງ
                        <span class="text-danger">* {{ errors.first('address_country') }}</span>
                        <span class="text-danger">{{ server_errors.address_country }}</span>
                    </label>
                    <div class="select">
                        <select
                            class="input"
                            name="address_country"
                            v-model="shippingAddress.address_country"
                            v-validate="'required'"
                        >
                            <option v-for="(c, i) in addressCountries" :key="i" :value="c.id">{{ c.name }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ເຂດ/ເມືອງ ( District )
                        <span class="text-danger">* {{ errors.first('address_district') }}</span>
                        <span class="text-danger">{{ server_errors.address_district }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="address_district"
                        v-model="shippingAddress.address_district"
                        v-validate="'required|max:255'"
                        maxlength="255"
                    >
                </div>
            </div>

            <div class="column is-full">
                <div class="control">
                    <label class="label">
                        ທີ່ຢູ່ເຕັມ ( Full Address )
                        <span class="text-danger">* {{ errors.first('address') }}</span>
                        <span class="text-danger">{{ server_errors.address }}</span>
                    </label>
                    <textarea
                        class="input"
                        rows="3"
                        name="address"
                        v-model="shippingAddress.address"
                        v-validate="'required'"
                    />
                </div>
            </div>
        </div>

        <button
            class="button"
            :class="{ 'is-loading': btnLoading }"
            :style="{ marginTop: '20px', width: '30%' }"
            @click="ValidateForm()"
        >
            ບັນທຶກການແກ້ໄຂ
        </button>
    </div>
</template>

<script>
import mixinsEditShippingAddress from '@coms/../../src/Mixins/Shipping-Addresses/Edit';
import { ValidateShipping } from '@coms/../../src/Plugins/Validation/Validate-Shipping';

export default {
    props: ['shippingAddress'],
    mixins: [mixinsEditShippingAddress],
    created() {
        ValidateShipping(this);
    },
};
</script>

<style lang="scss" scoped>
.button {
    &:hover {
        color: $white;
    }
}
</style>
